import Script from 'next/script';
import { getConsent, useConsentHandler } from '@/lib/consent';
import {
  ADALYSER_SCRIPT_URL,
  disableAdalyser,
  enableAdalyser,
  ensureAdalyserQueue,
  initialiseAdalyser,
  isAdalyserEnabled,
} from '@/lib/analytics/adalyser/client';
import { useAdalyserEnabled } from '@/lib/analytics/adalyser/useAdalyserEnabled';

const AdalyserScript = () => {
  const adalyserEnabled = useAdalyserEnabled();

  useConsentHandler('adalyser', ({ allowed }) => {
    if (allowed) {
      enableAdalyser();
      return;
    }

    const wasEnabled = isAdalyserEnabled();
    disableAdalyser();

    // adalyser.js cannot be unloaded in place; reload drops the runtime the same way GTM does.
    if (wasEnabled && typeof window !== 'undefined') {
      window.setTimeout(() => {
        if (!getConsent().allowed) {
          window.location.reload();
        }
      }, 0);
    }
  });

  if (!adalyserEnabled) {
    return null;
  }

  ensureAdalyserQueue();

  const handleReady = () => {
    if (!enableAdalyser()) {
      return;
    }

    initialiseAdalyser();
  };

  return (
    <Script
      id="adalyser-tracker"
      src={ADALYSER_SCRIPT_URL}
      strategy="afterInteractive"
      onReady={handleReady}
    />
  );
};

export default AdalyserScript;
